module.exports = __webpack_public_path__ + "static/media/iftarspecials.88c97b74.jpg";